import { UseFormRegisterReturn } from 'react-hook-form';
import { InterestRadioButton } from './interest-radio-button';
import { Typography } from '@/components';
import { Input } from '@/components/ui/input';
import { t } from 'i18next';

interface CountriesSectionProps {
  countries: { label: string; value: string }[];
  registration: Partial<UseFormRegisterReturn>;
  selectedCountries: string[];
  otherValue: string;
  onOtherChange: (value: string) => void;
  isCompanyForm?: boolean;
}

export function CountriesSection({
  countries,
  registration,
  selectedCountries,
  otherValue,
  onOtherChange,
  isCompanyForm,
}: CountriesSectionProps) {
  const OTHER_TECH_MAX = 50;
  const otherText = Array.isArray(otherValue) ? otherValue.join(', ') : (otherValue ?? '');
  const otherLength = otherText.length;
  return (
    <div className="space-y-2">
      {isCompanyForm ? (
        <div className="mb-4 space-y-0.5">
          <Typography as="h4" color="primary" size="body-1" weight="semibold">
            {t('Countries')}
          </Typography>
        </div>
      ) : (
        <div className="space-y-0.5">
          <Typography as="h4" color="primary" size="title" weight="semibold">
            {t('In Which countries?')}
          </Typography>
          <Typography as="p" size="body-3" color="secondary" weight="normal" className="mt-1">
            {t('You can select more than one option')}
          </Typography>
        </div>
      )}
      <div className="flex flex-wrap justify-left gap-2 md:justify-start">
        {countries.map(({ label, value }) => (
          <InterestRadioButton
            key={value}
            id={`country-${value}`}
            value={value}
            registration={registration}
            isSelected={selectedCountries.includes(value)}
          >
            <span>{label}</span>
          </InterestRadioButton>
        ))}
        <Input
          placeholder="Other:"
          maxLength={OTHER_TECH_MAX}
          value={otherValue ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onOtherChange(e.target.value)}
          className="text-base-primary h-auto w-full rounded-lg border px-4 py-2 text-sm font-medium transition-all focus:ring-2 focus:ring-offset-2 md:w-auto md:min-w-[200px] md:text-base"
          style={{
            borderColor: '#279D59',
            backgroundColor: 'white',
          }}
        />
        <Typography as="p" size="body-3" color="secondary" className="mt-1">
          {otherLength}/{OTHER_TECH_MAX}
        </Typography>
      </div>
    </div>
  );
}
